import { render, staticRenderFns } from "./StoresTable.vue?vue&type=template&id=10c091ba"
import script from "./StoresTable.vue?vue&type=script&lang=js"
export * from "./StoresTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports